import { render, staticRenderFns } from "./ZSvgCommentAnswer.vue?vue&type=template&id=51e2bb1c&scoped=true&"
import script from "./ZSvgCommentAnswer.vue?vue&type=script&lang=js&"
export * from "./ZSvgCommentAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e2bb1c",
  null
  
)

export default component.exports